import result1Original from "./real_result_1_dashboard-optimized.jpg";
import result1Small from "./real_result_1_dashboard-480.webp";
import result1Medium from "./real_result_1_dashboard-768.webp";
import result2Original from "./real_result_2_project_management-optimized.jpg";
import result2Small from "./real_result_2_project_management-480.webp";
import result2Medium from "./real_result_2_project_management-768.webp";
import result3Original from "./real_result_3_deployment-optimized.jpg";
import result3Small from "./real_result_3_deployment-480.webp";
import result3Medium from "./real_result_3_deployment-768.webp";
import result4Original from "./real_result_4_saas_analytics-optimized.jpg";
import result4Small from "./real_result_4_saas_analytics-480.webp";
import result4Medium from "./real_result_4_saas_analytics-768.webp";

function responsiveImage(original, small, medium) {
  return {
    src: original,
    srcSet: `${small} 480w, ${medium} 768w, ${original} 1024w`,
  };
}

export const resultImage1 = responsiveImage(result1Original, result1Small, result1Medium);
export const resultImage2 = responsiveImage(result2Original, result2Small, result2Medium);
export const resultImage3 = responsiveImage(result3Original, result3Small, result3Medium);
export const resultImage4 = responsiveImage(result4Original, result4Small, result4Medium);
